import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EssentialService } from '../../services/essential.service';
import { MenuService } from '../../services/menu.service';


declare const $: any;

@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.css']
  // providers:[MenuService]
})
export class SubMenuComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;

  menuSiblings: any = [];
  allPages: any = [];
  parenMenu: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private essentialsService: EssentialService,
    public menuService: MenuService) { }

  menuContentTheme: string; // all, parent-children, parents, children

  activeMenu: { parent: number };
  flatMenu: any[] = [];

  ngOnInit() {
    this.menuContentTheme = this.settings.menuContentTheme || 'all';
    let slug = this.route.data['value'].data[0].slug;
    this.menuService.getMenu(this.settings.selectedCategory, this.data, slug);

    this.route.paramMap.subscribe(
      route => {
        slug = this.route.data['value'].data[0].slug;
        this.menuService.setActiveLink(this.settings.selectedCategory, slug);
      }
    )
  }

}


